export default __webpack_public_path__ + "static/media/baby.fe679289.jpg";